import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/offer';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById('hero-cta');
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, []);
  return <AnimatePresence data-id="element-21" data-mp="2av1tc76drn2s">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-[max(12px,env(safe-area-inset-bottom))] pt-3" data-id="element-22" data-mp="38ayz6oxtmpld">
          <a href={CHECKOUT_URL} onClick={() => window.fbq?.('track', 'InitiateCheckout', {
        value: 27,
        currency: 'USD'
      })} className="mx-auto flex w-full max-w-md items-center justify-center gap-2 rounded-2xl bg-gold px-5 py-4 font-display text-[17px] font-black uppercase tracking-tight text-ink shadow-cta ring-2 ring-ink/80 motion-safe:animate-shake" data-id="element-23" data-mp="333sus47knawv">
            Get instant access · $27
            <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-24" data-mp="2kecot1d4aq92" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}